module.exports = __webpack_public_path__ + "static/media/1POLICY23.6d5e1f63.jpg";